module.exports = __webpack_public_path__ + "static/habits-desktop-cb5ab44477afa585110c6712fa90a49f.webp";